import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MatButtonToggleChange } from "@angular/material/button-toggle";
import { Cerere } from "src/app/components/cereri/cerere.interface";
import { helper } from "src/environments/helper";
import Swal from "sweetalert2";
import { DialogService } from "src/app/utils/dialog.service";
import { MatDialog } from "@angular/material/dialog";
import { CereriService } from "src/app/components/cereri/cereri.service";

@Component({
    selector: "app-subsemnat",
    templateUrl: "./subsemnat.component.html",
    styleUrls: ["./subsemnat.component.scss"],
})
export class SubsemnatComponent {
    @Input() cerere!: Cerere;
    @Output() cerereChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
    isPersoanaFizica = true;
    isPersoanaJuridica = true;
    selectedSubsemnatulStatus = "info";
    selectedPJFiles = "info";
    selectedBeneficiaryInfoStatus = "info";
    selectedFirmaInfoStatus = "info";
    helper = helper;

    onSubsemnatulInfoChange(event: MatButtonToggleChange) {
        this.selectedSubsemnatulStatus = event.value;
    }

    onPJInfoFilesChange(event: MatButtonToggleChange) {
        this.selectedPJFiles = event.value;
    }

    onBeneficiarInfoChange(event: MatButtonToggleChange) {
        this.selectedBeneficiaryInfoStatus = event.value;
    }

    constructor(
        private dialog: MatDialog,
        private dialogService: DialogService,
        private cereriService: CereriService
    ) { }

    onFirmaInfoChange(event: MatButtonToggleChange) {
        this.selectedFirmaInfoStatus = event.value;
    }

    get hasPunctLucru(): boolean {
        const punctLucru = (this.cerere as any)?.punct_lucru;

        if (!punctLucru) {
            return false;
        }

        return Object.values(punctLucru).some(
            (value) => value !== null && value !== undefined && value !== ""
        );
    }
    updateInformatiiCerere(customerData: string, customerType: number) {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: "O sa actualizati valoarea campului selectat. Sunteti sigur?",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            input: "text", // Enable text input
            inputValue: this.cerere?.informatii[customerData] ?? "",
            inputPlaceholder: "Completati valoarea dorita",
            inputValidator: (value) => {
                if (!value) {
                    return "Este necesar completarea unui motiv!";
                }
                return null; // Return null if input is valid
            },
            showLoaderOnConfirm: true,
            preConfirm: (inputValue) => {
                return this.cereriService
                    .cerereUpdateMetadate(this.cerere?.id_cerere ?? 0, {
                        key: customerData,
                        value: inputValue,
                        type: customerType,
                    })
                    .toPromise()
                    .then((response: any) => {
                        return response;
                        // reset info on View
                    })
                    .catch((error: any) => {
                        Swal.showValidationMessage(`Request failed: ${error}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: "Metadate actualizate cu succes!",
                    icon: "success",
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.cerereChanged.emit(true);
                });
            }
        });
    }

    mapTipReprezentant(controlValue: string) {
        if (controlValue) {
            if (controlValue == '1') {
                return 'Administrator/Asociat';
            } else if (controlValue == '2') {
                return 'Împuternicit';
            }
        }

        return 'N/A';
    }
}
